export default __webpack_public_path__ + "static/media/cross-circle-solid.05aca13d.svg";